export * from './angularfire2';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/angularfire2/index.js
// module id = ../../../../angularfire2/index.js
// module chunks = 4